import {Component, Input} from '@angular/core';

@Component({
    selector: 'bs-login-notification',
    template: require('./notification.template.html')
})
export class NotificationComponent {

    @Input('bgClass') bgClass: string;

    getNotificationClasses() {
        return {
            'login-notification': true,
            [this.bgClass]: !!this.bgClass
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/login/notification/notification.component.ts